import { render, staticRenderFns } from "./RegistroPatronal.vue?vue&type=template&id=2471d272&scoped=true"
import script from "./RegistroPatronal.vue?vue&type=script&lang=js"
export * from "./RegistroPatronal.vue?vue&type=script&lang=js"
import style0 from "./RegistroPatronal.vue?vue&type=style&index=0&id=2471d272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471d272",
  null
  
)

export default component.exports